import { render, staticRenderFns } from "./o-clients-v2.vue?vue&type=template&id=a712e0e2&scoped=true"
import script from "./o-clients-v2.vue?vue&type=script&lang=js"
export * from "./o-clients-v2.vue?vue&type=script&lang=js"
import style0 from "./o-clients-v2.vue?vue&type=style&index=0&id=a712e0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a712e0e2",
  null
  
)

export default component.exports